export default "__VITE_ASSET__CWx1r_hL__"